// import external dependencies
import 'jquery';

(function($) {

     $(document).ready(function() {
        wireupModalOpeners();
         wireupModalContentWithAutoOpeners();
        wireupModalCloseButton();
    });

    function wireupModalOpeners() {
        $('.serenity-modal-opener').click(function(e){
            e.preventDefault();
            var $opener = $(this);
            var contentID = $opener.data('modal-content-id');
            contentID = contentID.replace('modal-content_', ''); // for backward compatibility

            var $content = $('.serenity-modal-content[data-modal-content-id="' + contentID + '"]');
            if ($content.length == 0) { // backward compatibility
                $content = $('#' + contentID);
            }
            openModal($content);
        });
    }

    function wireupModalContentWithAutoOpeners() {
        $('.serenity-modal-content.auto-open').each(function() {
            var $content = $(this);
            var delay = $content.data('auto-open-delay');

            var contentID = $content.data('modal-content-id');

            if (checkIfOpenedModalExists(contentID) === false) {
                setTimeout(function () {
                    openModal($content);
                    addOpenedModal(contentID);
                }, delay);
            }
        });
    }

    function wireupModalCloseButton() {
        $('body').on('click', '.serenity-modal .button_close-modal, .serenity-modal .close-modal, .serenity-modal .modal-background', function(){
            closeModal();
        });
    }

    function openModal($content) {

        clearModal();

        var $body = $('body');

        var $modal = $('.serenity-modal');
        if ($modal.length == 0) {
            $modal = createModal();
            $body.append($modal);
        }

        var contentBackgroundClass = $content.data('content-background');
        $modal.removeClass('modal-content-background-white');
        $modal.removeClass('modal-content-background-black');
        $modal.removeClass('modal-content-background-transparent');
        $modal.addClass('modal-content-background-' + contentBackgroundClass);

        var contentAlignmentClass = $content.data('content-alignment');
        $modal.removeClass('modal-content-alignment-white');
        $modal.removeClass('modal-content-alignment-black');
        $modal.removeClass('modal-content-alignment-transparent');
        $modal.addClass('modal-content-alignment-' + contentAlignmentClass);

        var modalBackgroundClass = $content.data('modal-background');
        $modal.removeClass('modal-background-dark');
        $modal.removeClass('modal-background-light');
        $modal.removeClass('modal-background-transparent');
        $modal.addClass('modal-background-' + modalBackgroundClass);

        /*
        var modalBackgroundClass = $content.data('modal-background');
        var $modalBackground = $modal.find('.modal-background');
        $modalBackground.removeClass('modal-background-dark');
        $modalBackground.removeClass('modal-background-light');
        $modalBackground.removeClass('modal-background-transparent');
        $modalBackground.addClass('modal-background-' + modalBackgroundClass);
        */

        var $innerContent = $modal.find('.inner-content');
        var $duplicateContent = $content.clone();

        // add autoplay to video src
        if ($content.data('autoplay-video') == true) {
            var $videoIframe = $duplicateContent.find('iframe');
            var iframeSrc = $videoIframe.attr('src');
            if (iframeSrc.indexOf('vimeo') !== -1) {
                var newIframeSrc = iframeSrc;
                var autoplayArgument = 'autoplay=1';
                if (iframeSrc.indexOf('?') !== -1) {
                    newIframeSrc = iframeSrc + '&' + autoplayArgument;
                } else {
                    newIframeSrc = iframeSrc + '?' + autoplayArgument;
                }
                $videoIframe.attr('src', newIframeSrc);
            }
        }


        $innerContent.append($duplicateContent);

        setTimeout(function() {
            $modal.addClass('active');
            $body.addClass('modal-opened');
        }, 100);
    }

    function createModal() {

        var $modal = $(document.createElement('div')).addClass('serenity-modal');
        var $innerContent = $(document.createElement('div')).addClass('inner-content');
        var $modalBackground = $(document.createElement('div')).addClass('modal-background');
        var $closeButton = $(document.createElement('div')).addClass('button_close-modal').text('x');

        $innerContent.append($closeButton);
        $innerContent.append($modalBackground);
        $modal.append($innerContent);

        return $modal;
    }

    function clearModal() {
        var $modal = $('.serenity-modal'); // bootstrap has styles for .modal that we don't want
        $modal.find('.serenity-modal-content').remove();
    }

    function closeModal() {
        clearModal();
        var $modal = $('.serenity-modal');
        $modal.removeClass('active');
        $('body').removeClass('modal-opened');
    }

    function getOpenedModals() {

        var modals = sessionStorage.getItem('auto-opened-modals');
        if ((modals) && (modals !== 1)) {
            return JSON.parse(modals);
        } else {
            return [];
        }
    }

    function updateOpenedModals(modals) {
        sessionStorage.setItem('auto-opened-modals', JSON.stringify(modals));
    }

    function addOpenedModal(modalID) {
        var modals = getOpenedModals();
        if (checkIfOpenedModalExists(modalID) == false) {
            modals.push(modalID);
            updateOpenedModals(modals);
        }
    }

    function checkIfOpenedModalExists(modalID) {
        var modals = getOpenedModals();
        if (modals.indexOf(modalID) === -1) {
            return false;
        } else {
            return true;
        }
    }

    /*
    function removeOpenedModals(modalID) {
        var modals = getOpenedModals();
        var index = modals.indexOf(modalID);
        if (index !== -1) {
            modals.splice(index, 1);
            updateOpenedModals(modals)
        }
    }
    */

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/serenity-modals.js